import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PK_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#PK_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M8 0h24v24H8V0z", fill: "#2F8D00" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0h8v24H0V0z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.43 15.306s-4.465 1.165-8.01-1.21-1.763-7.848-1.763-7.848c-1.849.269-4.753 7.015-.072 10.398 4.68 3.383 9.164.131 9.845-1.34zm-4.955-6.44l-2.371 1.16 2.502.446.337 2.446 1.417-2.083 2.789.188-2.184-1.63 1.162-2.175-2.174.995-1.615-1.518.137 2.172z",
      fill: "#F1F9FF"
    }
  ))
), a = t;
export {
  a as default
};
